'use strict';
// Pure materialize logic for the batch lane: turn a raw model result + the
// serialized assembler context into the exact `plan_text` the realtime path
// would have saved. CommonJS so Jest can require it and so the ESM client
// (batch-careplan.js) can import it. The CCM combined-note assembler lives in
// the ESM billing-generate.js, so it is INJECTED via deps.assembleCombined to
// keep this module Jest-loadable. assembleBhiBillingNote is already CJS.
const { assembleBhiBillingNote } = require('./bhi-billing');

// Copied verbatim from careplan-generate.js:445-457 (the realtime original STAYS in
// place — not shared/deleted). The Task 4b drift-guard test asserts the two copies
// remain textually identical.
const _KNOWN_SPECIALTY = /^(cardiology|psychiatry|ophthalmology|optometry|neurology|nephrology|urology|gastroenterology|hepatology|endocrinology|oncology|pulmonology|pulmonary|dermatology|hematology|rheumatology|orthopedics?|podiatry|gynecology|obstetrics|allergy|immunology|pain|palliative|primary|internal|family|pediatrics?|geriatrics?|surgery|otolaryngology|ent|sleep|wound|vascular|radiology|pathology|psychology|psychotherapy|counseling|nutrition|dietetics)$/i;

function reidentify(text, phiMap) {
  let result = text;
  Object.keys(phiMap || {}).forEach(function (token) {
    const escaped = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    result = result.replace(new RegExp(escaped, 'g'), phiMap[token]);
  });
  result = result.replace(/\[SPECIALIST_\d+\](\s+)(\w[\w-]*)/g, function (match, ws, next) {
    return _KNOWN_SPECIALTY.test(next) ? next : 'the specialist' + ws + next;
  });
  result = result.replace(/\[SPECIALIST_\d+\]/g, 'the specialist');
  return result;
}

function buildMaterializedNote(type, rawText, ctx, deps) {
  const c = ctx || {};
  const text = reidentify(rawText || '', c.phiMap || {});
  if (type === 'care_plan') return text;
  if (type === 'bhi_bn') {
    return assembleBhiBillingNote(c.patient, c.monthStr, text, c.cptCodes, c.totalMonthTime, c.activitySummary, c.carePlanOnFile);
  }
  if (type === 'bn_combined') {
    if (!deps || typeof deps.assembleCombined !== 'function') {
      throw new Error('buildMaterializedNote: bn_combined requires deps.assembleCombined');
    }
    return deps.assembleCombined(c.patient, c.monthStr, text, c.cptCodes, c.totalMonthTime, c.activitySummary,
      c.staffList, c.practiceName, c.cpHistory, c.apcmDecision, c.consentType, c.effectiveCcmCode);
  }
  throw new Error('buildMaterializedNote: unknown type ' + type);
}

module.exports = { reidentify, buildMaterializedNote };
